/**
 * @generated SignedSource<<9ddffd3b2176a73b6713964fcdc15b11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeOnly"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "floatProblemOnly"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "outstandingSOOnly"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellerAccountId"
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "activeonly",
        "variableName": "activeOnly"
      },
      {
        "kind": "Variable",
        "name": "direction",
        "variableName": "direction"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "floatproblemonly",
        "variableName": "floatProblemOnly"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "orderby",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "outstandingsoonly",
        "variableName": "outstandingSOOnly"
      },
      {
        "kind": "Variable",
        "name": "reselleraccountid",
        "variableName": "resellerAccountId"
      }
    ],
    "concreteType": "CustomerSearchResultsConnection",
    "kind": "LinkedField",
    "name": "accountsearchforcustomer4",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerSearchResult",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountNum",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPhone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "floatProblem",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declineCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastDeclineReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastDeclineChargeAmount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerProblemsQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResellerProblemsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "560c38fa68d84c6f3588cb54952280f1",
    "id": null,
    "metadata": {},
    "name": "ResellerProblemsQuery",
    "operationKind": "query",
    "text": "query ResellerProblemsQuery(\n  $resellerAccountId: UUID!\n  $activeOnly: Int\n  $floatProblemOnly: Int\n  $outstandingSOOnly: Int\n  $orderBy: Int\n  $direction: Int\n  $first: Int\n  $offset: Int\n) {\n  accountsearchforcustomer4(reselleraccountid: $resellerAccountId, activeonly: $activeOnly, floatproblemonly: $floatProblemOnly, outstandingsoonly: $outstandingSOOnly, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      accountId\n      accountName\n      accountNum\n      contactLastName\n      contactFirstName\n      contactEmail\n      contactPhone\n      accountStatus\n      floatProblem\n      declineCount\n      lastDeclineReason\n      lastDeclineChargeAmount\n    }\n  }\n}\n"
  }
};
})();

node.hash = "cbeb36760ee974b8838bb32c21199040";

module.exports = node;
